// src/components/data-sources/components/SortableHeader.tsx

import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { SortField, SortDirection } from '../../../types/files';

interface SortableHeaderProps {
    field: SortField;
    currentSort: {
        field: SortField;
        direction: SortDirection;
    };
    onSort: (field: SortField) => void;
    children: React.ReactNode;
    className?: string;
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({
                                                                  field,
                                                                  currentSort,
                                                                  onSort,
                                                                  children,
                                                                  className = ''
                                                              }) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        onSort(field);
    };

    return (
        <th
            onClick={handleClick}
            className={`sortable-header cursor-pointer ${className}`}
            role="columnheader"
            aria-sort={
                currentSort.field === field
                    ? currentSort.direction === 'asc'
                        ? 'ascending'
                        : 'descending'
                    : 'none'
            }
        >
            <div className="d-flex align-items-center">
                {children}
                {currentSort.field === field && (
                    currentSort.direction === 'asc'
                        ? <ChevronUp size={16} className="ms-1" aria-hidden="true" />
                        : <ChevronDown size={16} className="ms-1" aria-hidden="true" />
                )}
            </div>
        </th>
    );
};

export default SortableHeader;